import { Link } from 'react-router-dom';

export default function ServiceTypesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
            Nos Services par Type de Fenêtre
          </h2>
          <p className="text-xl text-gray-600">
            Expertise complète pour tous les matériaux
          </p>
        </div>

        <div className="space-y-12">
          {/* PVC Section */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="order-2 lg:order-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-window-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Réparation Fenêtres PVC
              </h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Expert en réparation de fenêtres PVC à Lyon. Nous intervenons sur tous les problèmes : vitrage embué ou cassé, mécanismes défectueux, joints usés, problèmes d'étanchéité. Le PVC offre une excellente isolation thermique et phonique avec un entretien minimal.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Remplacement de vitrage double ou triple</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Réparation de mécanismes et poignées</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Changement de joints d'étanchéité</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Ajustement et réglage des ouvrants</span>
                </li>
              </ul>
              <Link
                to="/reparation-fenetre-pvc-lyon"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
                <img
                  src="https://public.readdy.ai/ai/img_res/1deb100b3937384aaa93239c81b00969.jpg"
                  alt="Réparation fenêtre PVC Lyon"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Bois Section */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20wooden%20window%20frame%20restoration%20close-up%2C%20natural%20wood%20grain%20texture%20detail%2C%20artisan%20carpentry%20work%20on%20traditional%20wood%20window%2C%20professional%20wood%20treatment%20and%20renovation%2C%20warm%20natural%20wood%20tones%2C%20simple%20clean%20background%20emphasizing%20craftsmanship%20and%20wood%20quality&width=600&height=400&seq=wood-window-service-001&orientation=landscape"
                  alt="Réparation fenêtre bois Lyon"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
            <div>
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-400 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-plant-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Réparation Fenêtres Bois
              </h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Artisan spécialisé en restauration de fenêtres bois à Lyon. Nous redonnons vie à vos menuiseries anciennes tout en préservant leur charme authentique. Le bois offre une isolation naturelle exceptionnelle et un cachet incomparable, particulièrement apprécié dans les immeubles anciens lyonnais.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Traitement anti-humidité et anti-insectes</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Réparation et consolidation des cadres</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Restauration de fenêtres anciennes</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                  <span className="text-gray-700">Lasure, peinture et finitions</span>
                </li>
              </ul>
              <Link
                to="/reparation-fenetre-bois-lyon"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-400 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Aluminium Section */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="order-2 lg:order-1">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-700 to-gray-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-layout-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Réparation Fenêtres Aluminium
              </h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Spécialiste des menuiseries aluminium à Lyon. Nous intervenons sur tous types de fenêtres alu modernes : baies coulissantes, fenêtres oscillo-battantes, châssis fixes. L'aluminium offre un design contemporain, une finesse des profilés et une durabilité exceptionnelle de 40 à 50 ans.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-gray-700 text-xl mt-1"></i>
                  <span className="text-gray-700">Réparation de baies coulissantes</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-gray-700 text-xl mt-1"></i>
                  <span className="text-gray-700">Remplacement de galets et rails</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-gray-700 text-xl mt-1"></i>
                  <span className="text-gray-700">Traitement anti-oxydation</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-gray-700 text-xl mt-1"></i>
                  <span className="text-gray-700">Réparation de châssis déformés</span>
                </li>
              </ul>
              <Link
                to="/reparation-fenetre-alu-lyon"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-gray-700 to-gray-600 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20window%20frame%20detail%2C%20contemporary%20grey%20metal%20window%20construction%2C%20professional%20aluminum%20sliding%20door%20mechanism%2C%20high-quality%20aluminum%20glazing%20system%2C%20clean%20minimalist%20design%2C%20simple%20neutral%20background%20showcasing%20aluminum%20window%20craftsmanship&width=600&height=400&seq=alu-window-service-001&orientation=landscape"
                  alt="Réparation fenêtre aluminium Lyon"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
